
import useUserIdentity from 'hooks/useUserIdentity';

const useCurrentIdentity = () => {
    const { currentIdentity } = useUserIdentity();
    return currentIdentity;

};

export default useCurrentIdentity;
